import styled from "styled-components";
import { getGridSize, space } from "@scriba/ui-lib";

export const StyledForm = styled("form")`
  padding-top: ${space("xl")}px;
  max-width: ${getGridSize(100)};
`;
